export interface Permission {
  id: string;
  key: string;
  description: string | null;
  module: string;
}

export type PermissionsByModule = Record<string, Permission[]>;

export const MODULE_LABEL: Record<string, string> = {
  usuarios: 'Usuários e Permissões',
  saques: 'Saques',
};

export const moduleLabel = (key: string): string =>
  MODULE_LABEL[key] ?? key.charAt(0).toUpperCase() + key.slice(1);

export const groupByModule = (perms: Permission[]): PermissionsByModule =>
  perms.reduce<PermissionsByModule>((acc, perm) => {
    const list = acc[perm.module] ?? [];
    list.push(perm);
    acc[perm.module] = list;
    return acc;
  }, {});
